import React,{ useEffect } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from "yup";
import { Translate } from "../../../../language";
import { updateWinery, getOneWineryById  } from "../../../actions/wineryActions";


const validationSchema = Yup.object().shape({
  Nwinery: Yup.string().required("El campo nombre es requerido"),
  Cwinery: Yup.string().required("El campo ciudad es requerido"),
  Dwinery: Yup.string().required("El campo departamento es requerido"),
 /*  Admwinery: Yup.string().required("El correo es requerido"), */
});

export default function UpdateWinery({setdata, match}) {
  let idWinery = match.params.idWinery

  const dispatch = useDispatch();
  const { winery } = useSelector((state) => state.wineriesAdmin);
  let ubication =  winery?.ubication

  useEffect(() => {
    dispatch(getOneWineryById (idWinery))
    
}, [])

console.log();
  return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          Nwinery: winery?.name,
          Cwinery: ubication?.city,
          Dwinery: ubication?.state,
        }}
        onSubmit={(values) => {
          console.log();
          dispatch(updateWinery(values,idWinery))
        }}
        validationSchema={validationSchema}
      >
        {(props) => (
          <Form>
            <label>Nombre Bodega</label>
            <Field type="text" name="Nwinery" placeholder="Nombre de Bodega" />
            <br />
            <ErrorMessage name="Nwinery" component="div" />
            <label>Ciudad</label>
            <Field type="text" name="Cwinery" placeholder="Ciudad" />
            <br />
            <ErrorMessage name="Cwinery" component="div" />
            <label>Departamento</label>
            <Field type="text" name="Dwinery" placeholder="Departamento" />
            <br />
            <ErrorMessage name="Dwinery" component="div" />
            <button type="submit">{Translate ('update','es')}</button>
          </Form>
        )}
      </Formik>
    
  );
}